export default "__VITE_ASSET__0Q9eCDC0__"